/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Label from "../Label";
import Icon from "../Icon";
import { StyledFormField } from "./StyledFormField";
import { useTranslate } from "../../../hooks/useTranslate";

const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const StyledSearchIcon = styled((props) => <Icon.Search {...props} />)`
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
`;

const SearchField = ({ name, label, defaultValue, placeholder, ...props }) => {
  const { _t } = useTranslate();

  return (
    <>
      {label ? <Label name={name}>{label}</Label> : undefined}
      <SearchInputWrapper>
        <StyledSearchIcon size={Icon.SIZE.SM} color="secondary" />
        <StyledFormField.Search id={name} type="search" defaultValue={defaultValue} placeholder={_t(placeholder)} {...props} />
      </SearchInputWrapper>
    </>
  );
};

export default SearchField;
